import {AppBar, Toolbar, Typography, Button, Container, Box, IconButton, MenuItem, Menu} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import {Link} from 'react-router-dom';
import React from 'react';
import {ReactComponent as Logo} from '../StarryNights_Logo_Small.svg'
import axios from "axios";
import Cookies from 'js-cookie';


const pages = [
    {name: 'All Queues', route: "/staff"}
];

function AdminNavbar() {

    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const csrfToken = Cookies.get('XSRF-TOKEN');

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleLogout = () => {
        axios.post('/logout', {}, {
            headers: {
                'X-CSRF-TOKEN': csrfToken
            }
        })
            .then(() => {
                // after logout
                Cookies.remove('isLoggedIn');
                window.location.href = '/';
            })
            .catch(error => {
                console.error('Logout Error', error);
            });
    };

    const LogoutButton = () => (
        <Button
            variant="contained"
            onClick={handleLogout}
            size="small"
            color="sfuRed"
            sx={{fontSize: '0.8rem', fontWeight: '600', marginInline: '25px'}}>
            Logout
        </Button>
    );

    return (
        <AppBar position="static">
            <Container maxWidth="xl">
                <Toolbar disableGutters sx={{justifyContent: 'space-between'}}>
                    <Box sx={{display: 'flex', alignItems: 'center'}}>
                        <Typography variant="h6" component="div">
                            <Link to="/" style={{textDecoration: 'none', color: 'inherit'}}>
                                <Logo style={{height: '40px', paddingTop: '5px'}}/>
                            </Link>
                        </Typography>
                        <Typography variant="h6" component="div" sx={{ marginLeft: '10px' }}>
                            ADMIN
                        </Typography>
                    </Box>
                    <Box sx={{flexGrow: 1, justifyContent: 'flex-end', paddingRight: '10 px', display: {xs: 'flex', md: 'none'}}}>
                        <IconButton
                            size="large"
                            aria-label="menu-options"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon/>
                        </IconButton>
                        <Menu
                            id="menu-options"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: {xs: 'block', md: 'none'},
                            }}
                        >
                            {pages.map((page) => (
                                <MenuItem component={Link} to={page.route} key={page.name} onClick={handleCloseNavMenu} sx={{paddingInline: '25px'}}>
                                    <Typography textAlign="center">{page.name}</Typography>
                                </MenuItem>
                            ))}
                            <LogoutButton/>
                        </Menu>
                    </Box>
                    <Box sx={{flexGrow: 1, justifyContent: 'flex-end',  paddingRight: '10 px', display: {xs: 'none', md: 'flex'}}}>
                        {pages.map((page) => (
                            <Button color="inherit" sx={{paddingInline: '25px'}} key={page.name}>
                                <Link to={page.route} style={{textDecoration: 'none', color: 'inherit'}}>{page.name}</Link>
                            </Button>
                        ))}
                        <LogoutButton/>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}

export default AdminNavbar;